module.exports = __webpack_public_path__ + "static/media/mmsc.ae2d99af.png";